































































import { Vue, Component, Prop } from 'vue-property-decorator'

export class Column {
  /**
   * Rowクラスのプロパティ名（例：rowLabel , period1 , period2 … , itemTotal）がidとなる
   */
  id!: string
  period?: number
  yearMonth?: string
  isCategoryColumn?: boolean
  isTotalColumn?: boolean
}

export class Cell {
  prospect?: number
  total?: number
}

export class Row {
  rowLabel!: string
  cells?: Record<string, Cell>
  itemTotal?: Cell
  isCategoryRow?: boolean
  isBlueTotalRow?: boolean
  isGrayTotalRow?: boolean
  isRedTotalRow?: boolean
}

@Component({
  components: {
    SmText: () => import('@/components/atoms/SmText.vue'),
    SmTableCell: () => import('@/components/atoms/SmTableCell.vue'),

    VueScrollingTable: () => import('@/components/external-packages/vue-scrolling-table/VueScrollingTable.vue'),
  }
})
export default class SmTableSimpleRepairPlanDetailPrint extends Vue {
  @Prop({ required: true })
  private readonly columns!: Column[]

  @Prop({ required: true })
  private readonly rows!: Row[]

  @Prop({ required: true })
  private readonly tableHeight!: string

  private getHeaderLabel(column: Column): string {
    if (column.isCategoryColumn) {
      return '修繕工事項目'
    } else if (column.isTotalColumn) {
      return '合計'
    }

    return column.period + '期\n' + column.yearMonth
  }

  private getBackgroundColorForRow(row: Row): string {
    if (row.isCategoryRow || row.isBlueTotalRow) {
      return 'sm__table-blue-row sm__table-tr'
    } else if (row.isGrayTotalRow) {
      return 'sm__table-gray-row sm__table-tr'
    } else if (row.isRedTotalRow) {
      return 'sm__table-red-row sm__table-tr'
    }
    return ''
  }
}
